import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  LineHeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from '../../styles/constants';

export const addressClassName = css({
  display: 'flex',
  flexDirection: 'column',
});

export const titleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  marginBottom: Spacing['2XS'],
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.COMPACT,
  },
});

export const subtitleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.NORMAL,
  lineHeight: LineHeight.LARGE,
});

export const rowClassName = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing['2XS'],
});
